@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
  <h2 mat-dialog-title>{{title}} '{{user.firstName}} {{user.lastName}}'</h2>
  <mat-dialog-content class="flex-col mt-3" [formGroup]="decisionForm">
    <mat-label>Verified</mat-label>
    <mat-checkbox color="primary" class="primary-checkbox" formControlName="verified">
    </mat-checkbox>
    <mat-form-field  appearance="outline" class="w-100 mt-3">
      <mat-label>Reason</mat-label>
      <input matInput formControlName="reason" required>
      @if (decisionForm.controls.reason.errors?.required) {
        <mat-error>Reason is required</mat-error>
      }
      @if (decisionForm.controls.reason.hasError('minlength')) {
        <mat-error>Reason isn't long enough, minimum of 5 characters</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row space-between items-center w-100 p-2">
      <button [disabled]="!canVerify" mat-flat-button class="w-40" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
      <button mat-flat-button class="w-40" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    </div>
  </mat-dialog-actions>
</div>

